/*
 * Variant-media gallery controller.
 *
 * The per-variant gallery (snippets/variant-media-gallery.liquid) renders, for the selected variant:
 *   hero (product.featured_image) -> shared-first -> variant featured -> variant media -> shared-rest
 * The <media-gallery> carries data-variant-media-gallery, which tells product-info.js's updateMedia()
 * to SKIP its own media diff (it only updates the viewer, not thumbnails, and crashes on the per-variant
 * thumbnail mismatch). So `event.data.html` arrives here pristine and we own the swap.
 *
 * On a variant change we:
 *   1. take the freshly re-rendered gallery for the new variant,
 *   2. drop the catalog hero (it leads only on initial page load),
 *   3. swap it into the DOM (the fresh custom elements upgrade and re-wire viewer + thumbnails),
 *   4. lead with the variant featured image, and
 *   5. refresh the zoom modal contents.
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const data = event && event.data;
    if (!data || !data.sectionId || !data.html) return;
    const sectionId = data.sectionId;

    // Live-update the "What's Included" song-pack-list name(s) for the new variant. The tab's
    // Liquid seeds each %VARIANT% occurrence as a <span data-song-pack-variant-name>; we swap
    // ONLY that span's text, leaving the rendered rich-text list markup intact. Runs ahead of
    // the gallery swap below so it still applies even if the gallery guards bail out.
    const variantTitle = data.variant && data.variant.title;
    if (variantTitle) {
      document.querySelectorAll('[data-song-pack-variant-name]').forEach((nameEl) => {
        nameEl.textContent = variantTitle;
      });
    }

    // Live-update the per-variant subtitle (variant metafield custom.variant_subtitle). The
    // custom-liquid block renders a #VariantSubtitle-<sectionId> element seeded for the selected
    // variant; swap its innerHTML from the freshly re-rendered HTML. Runs ahead of the gallery
    // swap below so it still applies even if the gallery guards bail out.
    const liveSubtitle = document.querySelector(`#VariantSubtitle-${sectionId}`);
    const freshSubtitle = data.html.querySelector(`#VariantSubtitle-${sectionId}`);
    if (liveSubtitle && freshSubtitle) liveSubtitle.innerHTML = freshSubtitle.innerHTML;

    const live = document.querySelector(`#MediaGallery-${sectionId}`);
    const fresh = data.html.querySelector(`#MediaGallery-${sectionId}`);
    if (!live || !fresh || !fresh.hasAttribute('data-variant-media-gallery')) return;

    // 2. Catalog hero is landing-only — remove its slide + thumbnail before swapping in.
    fresh.querySelectorAll('[data-variant-hero]').forEach((el) => el.remove());

    // 3. Swap the whole gallery. Inserting the parsed element upgrades the custom elements
    //    (media-gallery + slider-component), which re-wires the viewer and thumbnail listeners.
    live.replaceWith(fresh);

    // 4. Lead with the variant featured image.
    const featuredId = data.variant && data.variant.featured_media && data.variant.featured_media.id;
    if (featuredId && typeof fresh.setActiveMedia === 'function') {
      fresh.setActiveMedia(`${sectionId}-${featuredId}`, true);
    }

    // Keep the slider counter total in sync with the (hero-removed) slide count.
    const total = fresh.querySelectorAll('[id^="Slider-Gallery"] > li[data-media-id]').length;
    const totalEl = fresh.querySelector('.slider-counter--total');
    if (totalEl) totalEl.textContent = total;

    // 5. Refresh the zoom modal (Taste's updateMedia is skipped for our gallery).
    const liveModal = document.querySelector(`#ProductModal-${sectionId} .product-media-modal__content`);
    const freshModal = data.html.querySelector(`#ProductModal-${sectionId} .product-media-modal__content`);
    if (liveModal && freshModal) liveModal.innerHTML = freshModal.innerHTML;
  });
})();
